<onyx-icon-box class="bar-icon" color="white" [size]="20" [hasShadow]="true">
  <onyx-icon [style.color]="color()" name="good-filled" [size]="14"></onyx-icon>
</onyx-icon-box>

<form [formGroup]="form()">
  @let controls = form().controls;
  <onyx-form-group class="type" [controls]="controls.type">
    <onyx-dropdown
      [formControl]="controls.type"
      [label]="first() ? 'labels.goodType' : undefined"
      [placeholder]="first() ? 'labels.choose' : 'labels.goodType'"
      [options]="GOOD_TYPE_SOURCE"
      [(query)]="goodTypeQuery"
      [showAddOption]="true"
      [addOptionMessage]="goodTypeAddOptionMessage() | translate"
      [size]="32"
      [showErrors]="false"
      (selectedOptionValueChange)="type$.next($event.value)"
      (addOption)="addGoodType($event)"
    ></onyx-dropdown>

    <onyx-suggestions
      [control]="controls.type"
      [suggestions]="typeSuggestions$ | async"
    ></onyx-suggestions>
  </onyx-form-group>

  <onyx-text-field
    class="reference-number"
    [formControl]="controls.referenceNumber"
    [label]="first() ? 'labels.goodReferenceNumber' : undefined"
    [placeholder]="first() ? undefined : 'labels.goodReferenceNumber'"
    [size]="32"
  ></onyx-text-field>

  <onyx-form-group class="unit" [controls]="controls.unit">
    <onyx-dropdown
      [formControl]="controls.unit"
      [label]="first() ? 'labels.unit' : undefined"
      [placeholder]="first() ? 'labels.choose' : 'labels.unit'"
      [options]="unitOptions$ | async"
      [showAddOption]="true"
      [size]="32"
      [showErrors]="false"
      (selectedOptionChange)="
        $event.isManual && unit$.next($any($event.option)?.unit ?? null)
      "
      (addOption)="addUnit($event)"
    ></onyx-dropdown>

    <onyx-suggestions
      [control]="controls.unit"
      [suggestions]="unitSuggestions$ | async"
    ></onyx-suggestions>
  </onyx-form-group>

  <onyx-form-group class="weight" [controls]="controls.totalWeight">
    <onyx-text-field
      [formControl]="controls.totalWeight"
      [warning]="controls.totalWeight.value | unitWarning: 'goodsWeight'"
      [label]="first() ? 'labels.totalWeight' : undefined"
      [placeholder]="first() ? undefined : 'labels.totalWeight'"
      [decimalPlaces]="0"
      unit="kg"
      [size]="32"
      [showErrors]="false"
    ></onyx-text-field>

    <onyx-suggestions
      [control]="controls.totalWeight"
      [suggestions]="
        (controls.totalWeight.value | unitSuggestions: 'goodsWeight') ??
        (isDedicated() ? DEDICATED_WEIGHT_SUGGESTIONS : [])
      "
    ></onyx-suggestions>
  </onyx-form-group>

  <ng-container [formGroup]="controls.size">
    @let sizeControls = controls.size.controls;
    <onyx-tabs
      class="size-type"
      [formControl]="sizeControls.type"
      [label]="first() ? 'labels.size' : undefined"
      [hint]="
        sizeType() === GoodsSizeType.DIMENSIONS ? `${I18N}.sizeHint` : undefined
      "
      [tabs]="sizeTypes$ | async"
    ></onyx-tabs>

    @switch (sizeType()) {
      @case (GoodsSizeType.LOADING_METERS) {
        <onyx-form-group
          class="size-value"
          [controls]="sizeControls.loadingMeters"
        >
          <onyx-text-field
            [formControl]="sizeControls.loadingMeters"
            [warning]="
              sizeControls.loadingMeters.value | unitWarning: 'loadingMeters'
            "
            [label]="first() ? 'labels.loadingMeters' : undefined"
            [placeholder]="first() ? undefined : 'labels.loadingMeters'"
            [decimalPlaces]="2"
            unit="LDM"
            [size]="32"
            [showErrors]="false"
          ></onyx-text-field>

          <onyx-suggestions
            [control]="sizeControls.loadingMeters"
            [suggestions]="loadingMetersSuggestions$ | async"
          ></onyx-suggestions>
        </onyx-form-group>

        @if (showCoilWell()) {
          <onyx-checkbox
            class="coil-well"
            [formControl]="sizeControls.requiresCoilWell"
            label="labels.coilWell"
            [showErrors]="false"
          ></onyx-checkbox>
        }
      }

      @case (GoodsSizeType.DIMENSIONS) {
        @let dimensionsSuggestions = dimensionsSuggestions$ | async;

        <onyx-form-group
          class="size-dimensions"
          [controls]="sizeControls.length"
        >
          <onyx-text-field
            [formControl]="sizeControls.length"
            [warning]="sizeControls.length.value | unitWarning: 'cargoLength'"
            [label]="first() ? 'labels.length' : undefined"
            [placeholder]="first() ? undefined : 'labels.length'"
            [decimalPlaces]="2"
            unit="m"
            [size]="32"
            [showErrors]="false"
          ></onyx-text-field>

          <onyx-suggestions
            [control]="sizeControls.length"
            [suggestions]="
              (sizeControls.length.value | unitSuggestions: 'cargoLength') ??
              dimensionsSuggestions?.['length'] ??
              []
            "
          ></onyx-suggestions>
        </onyx-form-group>

        <onyx-form-group
          class="size-dimensions"
          [controls]="sizeControls.width"
        >
          <onyx-text-field
            [formControl]="sizeControls.width"
            [warning]="sizeControls.width.value | unitWarning: 'cargoWidth'"
            [label]="first() ? 'labels.width' : undefined"
            [placeholder]="first() ? undefined : 'labels.width'"
            [decimalPlaces]="2"
            unit="m"
            [size]="32"
            [showErrors]="false"
          ></onyx-text-field>

          <onyx-suggestions
            [control]="sizeControls.width"
            [suggestions]="
              (sizeControls.width.value | unitSuggestions: 'cargoWidth') ??
              dimensionsSuggestions?.['width'] ??
              []
            "
          ></onyx-suggestions>
        </onyx-form-group>

        <onyx-form-group
          class="size-dimensions"
          [controls]="sizeControls.height"
        >
          <onyx-text-field
            [formControl]="sizeControls.height"
            [warning]="sizeControls.height.value | unitWarning: 'cargoHeight'"
            [label]="first() ? 'labels.height' : undefined"
            [placeholder]="first() ? undefined : 'labels.height'"
            [decimalPlaces]="2"
            unit="m"
            [size]="32"
            [showErrors]="false"
          ></onyx-text-field>

          <onyx-suggestions
            [control]="sizeControls.height"
            [suggestions]="
              (sizeControls.height.value | unitSuggestions: 'cargoHeight') ??
              dimensionsSuggestions?.['height'] ??
              []
            "
          ></onyx-suggestions>
        </onyx-form-group>

        <onyx-form-group class="size-dimensions" [controls]="controls.quantity">
          <onyx-text-field
            [formControl]="controls.quantity"
            [label]="first() ? 'labels.quantity' : undefined"
            [placeholder]="first() ? undefined : 'labels.quantity'"
            [decimalPlaces]="0"
            [size]="32"
            unit="units.pieces"
            [showErrors]="false"
          ></onyx-text-field>

          <onyx-suggestions
            [control]="controls.quantity"
            [suggestions]="QUANTITY_SUGGESTIONS"
          ></onyx-suggestions>
        </onyx-form-group>
      }

      @case (GoodsSizeType.VOLUME) {
        <onyx-form-group class="size-value" [controls]="sizeControls.volume">
          <onyx-text-field
            [formControl]="sizeControls.volume"
            [warning]="sizeControls.volume.value | unitWarning: 'volume'"
            [label]="first() ? 'labels.volume' : undefined"
            [placeholder]="first() ? undefined : 'labels.volume'"
            [decimalPlaces]="3"
            unit="m³"
            [size]="32"
            [showErrors]="false"
          ></onyx-text-field>

          <onyx-suggestions
            [control]="sizeControls.volume"
            [suggestions]="volumeSuggestions$ | async"
          ></onyx-suggestions>
        </onyx-form-group>
      }
    }
  </ng-container>

  <onyx-icon-button
    class="remove"
    variant="transparent"
    color="gray"
    [size]="32"
    icon="delete-outlined"
    (click)="remove.emit()"
  ></onyx-icon-button>

  @if (hasUnitedNationsNumber()) {
    <onyx-text-field
      class="united-nations-number"
      [formControl]="controls.unitedNationsNumber"
      label="labels.unitedNations"
      [maxLength]="4"
      [size]="32"
    ></onyx-text-field>
  }

  @if (hasStatisticalNumber()) {
    <onyx-text-field
      class="statistical-number"
      [formControl]="controls.statisticalNumber"
      label="labels.statisticalNumber"
      [size]="32"
    ></onyx-text-field>
  }
</form>
